import axios, { AxiosResponse } from 'axios';
import { ILeiContact, ILeiData } from 'types/leiTypes';

import { IZalozeniLeiResp } from './zalozeniLei';

const leiContactApi = (method: 'post' | 'get', varsym: string, idZadosti: number, data?: ILeiContact) => {
    return axios({
        method: method,
        url: `LEI/${varsym}/kontakt/${idZadosti}`,
        data: data
    }).then((resp: AxiosResponse<ILeiData>) => resp.data);
};

export const leiContactApiInit = (varsym: string) => {
    return axios({
        method: 'post',
        url: `LEI/${varsym}/kontakt`
    }).then((resp: AxiosResponse<IZalozeniLeiResp>) => resp.data);
};

export default leiContactApi;
